function filterFileBoxes(fileBoxes, query) {
  const normalizedQuery = query.toLowerCase()

  return fileBoxes.filter((fileBox) => fileBox.name.toLowerCase().includes(normalizedQuery))
}

function getInitialActiveIndex(fileBoxes) {
  const activeIndex = fileBoxes.findIndex((fileBox) => fileBox.active)

  if (activeIndex !== -1) {
    return activeIndex
  }

  return fileBoxes.length ? 0 : -1
}

function getWrappedIndex(index, step, itemCount) {
  if (!itemCount) {
    return -1
  }

  return (index + step + itemCount) % itemCount
}

export { filterFileBoxes, getInitialActiveIndex, getWrappedIndex }
